import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreOrganizationsByIdPatchAsyncSlice } from './patch';
import {
	coreSonarTasksByOrganizationIdReducers,
	coreSonarTasksByOrganizationIdWatchers
} from './tasks';

export const coreOrganizationsByIdReducers = combineReducers({
	patch: coreOrganizationsByIdPatchAsyncSlice.asyncReducers,
	tasks: coreSonarTasksByOrganizationIdReducers
});

export const coreOrganizationsByIdWatchers = combineAllWatchers([
	coreOrganizationsByIdPatchAsyncSlice.asyncWatchers,
	coreSonarTasksByOrganizationIdWatchers
]);
